// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3IHQ4","fileBtn":"File_fileBtn__38Otv","closeBtn":"File_closeBtn__2aZ5F","fileSelected":"File_fileSelected__oSToZ","disabled":"File_disabled__2CGD0"};